import devMode from './dev-mode';
import columnBreak from './utils/column-break';
import { linksCustomization, scrollTo, responsiveTables, homepageHoverEffect, parallaxEffect, followingCursor } from './partials/misc';
import scrollAnimations from './vendor/scrollAnimations-v2';
import popups from './partials/popups'
import { sliders } from './partials/sliders';
import notifications from '../../templates/sections/notifications/notifications';
import { video } from './partials/video';
import slidingTabs from '../../templates/sections/home/sliding-tabs';
import slidingBlocks from '../../templates/sections/home/sliding-blocks';
import { bannerVideo } from '../../templates/sections/banner/banner-video';
import admissionsProcess from '../../templates/sections/custom-templates/admissions-process';
import homepageAnimations from './partials/homepageAnimations';
//import { wpGallery } from './partials/galleries';

import buttons from './partials/buttons';
import menus from './partials/menus';

/* Flexible Content */
import accordion from '../../templates/blocks/accordion';
import tabs from '../../templates/blocks/tabs/tabs';
import textAndMedia from '../../templates/blocks/text-and-media/text-and-media';
//import media from '../../templates/blocks/media/media';
import text from '../../templates/blocks/text/text';
import floatingSkipLinks from '../../templates/blocks/floating-skip-links/floating-skip-links';
import secondarySchoolsStrip from '../../templates/blocks/secondary-schools-strip/index';


function consoleMessage(){	
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	document.querySelectorAll( '[data-hidden-on-load]' )?.forEach(function(el){
		el.removeAttribute('data-hidden-on-load')
	})
	
	// Init
	consoleMessage()
	usingJS()
	devMode()
	columnBreak()
	linksCustomization()
	scrollTo()
	responsiveTables()
	homepageAnimations()
	homepageHoverEffect()
	parallaxEffect()
	followingCursor()
	video()
	//wpGallery()
	buttons()
	menus()
	scrollAnimations()
	notifications()
	bannerVideo()
	slidingTabs()
	slidingBlocks()
	admissionsProcess()

	// Popups
	popups()

	// Sliders
	sliders()

	// Flexible Content
	accordion()
	tabs()
	textAndMedia()
	//media()
	text()
	floatingSkipLinks()
	secondarySchoolsStrip()
}



jQuery(document).ready(function ($) {
    ajax: {
		// allow popups to open once search
		const queryId = 123; // Replace `123` with your query ID.
		const query = window.searchAndFilter.frontend.queries.get( queryId );
		
		if ( query ) {
			// Only hook in to the update if dynamic update is enabled for the query.
			if ( query.getAttribute('resultsDynamicUpdate') === 'yes' ) {
				// Listen for the update to the results.
				query.on( 'get-results/start', function (queryObject) {
					// console.log("Start getting results.");
				} );

					// Listen for the update to the results.
				query.on( 'get-results/finish', function (queryObject) {
					// console.log("Finished getting results.");
					magnificPopup()
				} );
			}
		}
    }
    
});

